import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "../../lib/api";
import { useT } from "../../lib/i18n";

let cache = null;
export function useReviews() {
  const [d, setD] = useState(cache);
  useEffect(() => { if (cache) return; api.get("/public/reviews").then((r) => { cache = r.data; setD(r.data); }).catch(() => setD({ reviews: [] })); }, []);
  return d;
}

export function GoogleBadge({ dark = false, className = "" }) {
  const { t } = useT();
  const d = useReviews();
  const rating = d?.rating || (d?.reviews?.length ? d.reviews.reduce((a, r) => a + (Number(r.rating) || 5), 0) / d.reviews.length : null);
  const count = d?.count || d?.reviews?.length || 0;
  if (!rating || !count) return null;
  const inner = (
    <>
      <span className="flex gap-0.5 text-[#F4B400]" aria-hidden>{[1, 2, 3, 4, 5].map((i) => <Star key={i} size={13} fill={i <= Math.round(rating) ? "currentColor" : "none"} />)}</span>
      <span className="font-medium">{Number(rating).toFixed(1)}</span>
      <span className={dark ? "text-[#D6CEBF]" : "text-[#57534E]"}>· {count} {t("avis Google")}</span>
    </>
  );
  const cls = `inline-flex items-center gap-2 text-sm ${className}`;
  return d.google_url ? <a href={d.google_url} target="_blank" rel="noopener noreferrer" className={`${cls} hover:underline underline-offset-4`} data-testid="google-badge">{inner}</a> : <span className={cls} data-testid="google-badge">{inner}</span>;
}
